import { Button } from '#/modules/commonComponents/button';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatDisplayQty } from '#/utils/formatNumber';

function formatMtrNo(mtr) {
  return mtr?.mtrNo || '—';
}

function formatMtrName(mtr) {
  return mtr?.name || '—';
}

const SHORTAGE_ONLY_FILTER_OPTIONS = [
  { value: 'true', label: '僅缺料' },
];

/** 物料缺口列表欄位（對齊 material-shortage list）。 */
export function buildMaterialShortageColumns({
  filters = {},
  onFilterChange,
  onViewAffected,
} = {}) {
  return [
    {
      id: 'mtrNo',
      header: '料號',
      accessorFn: (row) => formatMtrNo(row.mtr),
      size: 160,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'mtrNo',
          label: '料號',
          filterValue: filters.mtrNo,
          onChange: (value) => onFilterChange?.('mtrNo', value),
          placeholder: '搜尋料號',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={formatMtrNo(row.original.mtr)} />
      ),
    },
    {
      id: 'mtrName',
      header: '名稱',
      accessorFn: (row) => formatMtrName(row.mtr),
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'mtrName',
          label: '名稱',
          filterValue: filters.mtrName,
          onChange: (value) => onFilterChange?.('mtrName', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={formatMtrName(row.original.mtr)} />
      ),
    },
    {
      id: 'actions',
      header: '影響工單',
      minSize: 90,
      size: 90,
      enableSorting: false,
      cell: ({ row }) => {
        const nos = row.original.affectedWorkOrderNos;
        const hasNos = Array.isArray(nos) && nos.length > 0;
        return (
          <Button
            type="button"
            size="sm"
            disabled={!hasNos || !onViewAffected}
            onClick={(event) => {
              event.stopPropagation();
              onViewAffected?.(row.original);
            }}
          >
            顯示
          </Button>
        );
      },
    },
    {
      id: 'shortageQty',
      header: '缺口',
      accessorFn: (row) => formatDisplayQty(row.shortageQty),
      size: 90,
      enableColumnFilter: true,
      meta: {
        ...createFixedMultiFilterMeta({
          key: 'shortageOnly',
          label: '缺料',
          options: SHORTAGE_ONLY_FILTER_OPTIONS,
          filterValue: filters.shortageOnly,
          onChange: (value) => onFilterChange?.('shortageOnly', value),
        }),
      },
    },
    {
      id: 'requiredQty',
      header: '需求',
      accessorFn: (row) => formatDisplayQty(row.requiredQty),
      size: 90,
    },
    {
      id: 'issuedQty',
      header: '已出庫',
      accessorFn: (row) => formatDisplayQty(row.issuedQty),
      size: 90,
    },
    {
      id: 'onHandAllocatedQty',
      header: '庫存',
      accessorFn: (row) => formatDisplayQty(row.onHandAllocatedQty),
      size: 90,
    },
    {
      id: 'inTransitAllocatedQty',
      header: '在途',
      accessorFn: (row) => formatDisplayQty(row.inTransitAllocatedQty),
      size: 90,
    },
    {
      id: 'unknownArrivalQty',
      header: '未排到貨',
      accessorFn: (row) => formatDisplayQty(row.unknownArrivalQty),
      size: 100,
    },
  ];
}
